<template lang="pug">
el-popover(placement="bottom" width="180" ref="pop")
  div(v-if="list.length == 0") 暂无数据
  .each(v-for="(item, i) in list" :key="i" @click="chooseType(item)")
    .fl.els {{showStr(item)}}
    .fr
      i.iconfont.icon-shenhezhong(v-if="item.checkStatus == 1")
      i.iconfont.icon-zhengque(v-else-if="item.checkStatus == 2")
      i.iconfont.icon-cuowu(v-else-if="item.checkStatus == 3")
      i.iconfont.icon-daishangchuan(v-else)
  div(slot="reference" style="overflow: hidden;cursor: pointer;")
    .fl
      i.el-icon-caret-bottom
    span {{showStr(curItem)}}
    .fr
      i.iconfont.icon-shenhezhong(v-if="curItem.checkStatus == 1")
      i.iconfont.icon-zhengque(v-else-if="curItem.checkStatus == 2")
      i.iconfont.icon-cuowu(v-else-if="curItem.checkStatus == 3")
      i.iconfont.icon-daishangchuan(v-else)
</template>

<script>
import { materialType2name } from '@/utils/config'

export default {
  name: 'OrderVideoDropdown',
  props: {
    value: {
      type: Object,
      default: function () { return {} }
    },
    list: {
      type: Array,
      default: function () { return [] }
    }
  },
  computed: {
    curItem: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    },
    showStr() {
      return e => {
        if (e.materialType) {
          if (e.materialType - 0 < 4) return e.screenTypeName + materialType2name[e.materialType - 0]
          else return materialType2name[e.materialType - 0]
        }
        return ''
      }
    }
  },
  methods: {
    chooseType(item) {
      this.curItem = item
      this.$emit('change', item)
      document.body.click()
    }
  }
}
</script>

<style lang="sass" scoped>
.each
    height: 30px
    line-height: 30px
    cursor: pointer
    .els
        width: 120px
i.iconfont
    margin-top: 2px
    &.icon-shenhezhong
        color: #FF7413
    &.icon-daishangchuan
        color: #999
    &.icon-zhengque
        color: #3FB536
    &.icon-cuowu
        color: #D50000

</style>

